import {Button, ButtonProps, useListContext, useNotify, useRecordContext,} from "react-admin";
import PublishIcon from "@material-ui/icons/Print";
import {clientNoJson} from "../../dataProvider";
import {url as URL} from "../../constants";
import {getFileNameFromContentDisposition} from "../../shared/utils";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";

export const Print2XDocumentsButton = (props: ButtonProps & { mission_max_page: number }) => {
  const { refetch } = useListContext();
  const record = useRecordContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    for (let i = 0; i < props.mission_max_page; i++) {

      let res = null;

      try {
        res = await clientNoJson(`${URL}/print_route_with_label_x2/`, {
          method: "POST",
          data: {
            id: record.id,
            mission_max_page: i
          },
          responseType: "arraybuffer",
        });
      } catch (err: any) {
        const decoder = new TextDecoder("utf-8");
        const text = decoder.decode(err.response.data);

        // 2. Parse JSON
        try {
          const json = JSON.parse(text);
          console.log("Errore con JSON:", json);
          notify("La delivery " + json.delivery + " non contiene bolle", "error");
        } catch (e) {
          notify("ra.message.error", "error");
        }

        setLoading(false);
        return;
      }
      if (i === props.mission_max_page - 1) {
        setLoading(false);
      }
      const data = res.data; // or res.blob() if using blob responses

      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: res.headers["content-type"],
        })
      );
      const actualFileName = getFileNameFromContentDisposition(
        res.headers["content-disposition"]
      );

      // uses the download attribute on a temporary anchor to trigger the browser
      // download behavior. if you need wider compatibility, you can replace this
      // part with a library such as filesaver.js
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", actualFileName);
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) link.parentNode.removeChild(link);
      try {
        refetch();
      }
      catch (e) {

      }

    }


  };

  return (
    <Button
      {...props}
      disabled={loading}
      label="X2+B"
      title="Stampa Bolle X2 + Borderaux"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
    </Button>
  );
};
